import { TableBody, TableCell, TableRow } from "@mui/material";
import { Skeleton } from "@mui/material";
import { Observer } from "mobx-react";
import React, { useCallback } from "react";
import AcxTableEmptyRow from "./AcxTableEmptyRow";
import AcxTableRow from "./AcxTableRow";
import AcxTableViewModel from "./AcxTableViewModel";

interface Props {
    viewMod: AcxTableViewModel;
}

function AcxTableBody(props: Props) {
    const onSelectChange = useCallback(
        (selected: boolean, key: string) => {
            props.viewMod.selectionChange(selected, key);
        },
        [props.viewMod],
    );

    const isSelected = useCallback(
        (key: string) => {
            return (
                props.viewMod.selectedItems.findIndex((k) => k === key) !== -1
            );
        },
        [props.viewMod.selectedItems],
    );

    const isDisabled = useCallback(
        (key: string) => {
            return (
                props.viewMod.disabledItems.findIndex((k) => k === key) !== -1
            );
        },
        [props.viewMod.disabledItems],
    );

    // Helper functions for sx props
    const getCellSx = () =>
        props.viewMod.enableDense
            ? {
                  paddingLeft: 1,
                  paddingRight: 1,
                  paddingTop: 1,
                  paddingBottom: 1,
                  fontSize: "13px",
              }
            : {
                  paddingLeft: 2,
                  paddingRight: 2,
                  paddingTop: 2,
                  paddingBottom: 2,
                  fontSize: "13px",
              };
    const getRowSx = () => {
        let sx: any = {};
        if (props.viewMod.enableHover) {
            sx["&:hover"] = {
                backgroundColor: "rgba(0,0,0,0.01) !important",
            };
        }
        if (props.viewMod.enableStripes) {
            sx["&:nth-of-type(even)"] = {
                backgroundColor: "rgba(238,238,238,0.1)",
            };
        }
        return sx;
    };

    return (
        <Observer>
            {() => (
                <TableBody>
                    {props.viewMod.isLoading && props.viewMod.skeletonRows ? (
                        <>
                            {Array.from(Array(props.viewMod.skeletonRows)).map(
                                (row, rowI) => (
                                    <TableRow key={`row_${rowI}`}>
                                        {props.viewMod.tableCols.map(
                                            (col, colI) => (
                                                <TableCell
                                                    key={`row_${rowI}_col_${colI}`}
                                                    sx={getCellSx()}
                                                >
                                                    <Skeleton
                                                        style={{
                                                            maxWidth: "none",
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </Skeleton>
                                                </TableCell>
                                            ),
                                        )}
                                    </TableRow>
                                ),
                            )}
                        </>
                    ) : (
                        <>
                            {props.viewMod.renderRows &&
                            props.viewMod.renderRows.length === 0 ? (
                                <AcxTableEmptyRow
                                    columns={props.viewMod.tableCols}
                                    enableCheck={props.viewMod.enableCheck}
                                    rowSx={getRowSx()}
                                />
                            ) : (
                                props.viewMod.renderRows.map((row, rowNum) => {
                                    if (
                                        rowNum >=
                                            props.viewMod._virtualBeginRow &&
                                        rowNum <= props.viewMod._virtualEndRow
                                    ) {
                                        return (
                                            <AcxTableRow
                                                key={`${props.viewMod.id}-table_row_${rowNum}`}
                                                row={row}
                                                columns={
                                                    props.viewMod.tableCols
                                                }
                                                r={rowNum}
                                                enableCheck={
                                                    props.viewMod.enableCheck
                                                }
                                                onSelectChange={onSelectChange}
                                                keyField={
                                                    props.viewMod.keyField
                                                }
                                                selected={isSelected(
                                                    row[props.viewMod.keyField],
                                                )}
                                                disabled={isDisabled(
                                                    row[props.viewMod.keyField],
                                                )}
                                                cellSx={getCellSx()}
                                                rowSx={getRowSx()}
                                                onShiftClick={
                                                    props.viewMod
                                                        .onRowShiftClick
                                                }
                                                waypoint={
                                                    props.viewMod.shouldRenderWaypoint(
                                                        rowNum,
                                                    ) ? (
                                                        undefined // wayppoint disabled for now <Waypoint
                                                    ) : undefined
                                                }
                                            />
                                        );
                                    } else {
                                        // return <React.Fragment key={`${props.viewMod.id}-table_row_${rowNum}`}></React.Fragment>;
                                        return null;
                                    }
                                })
                            )}
                        </>
                    )}
                </TableBody>
            )}
        </Observer>
    );
}

export default AcxTableBody;
